function normalizeFeeDescription(description = '') {
  return description.toLowerCase() === 'amenity_fee' ? 'Amenity' : description
}

export function getDedupedFeeTotals(taxesAndFees = []) {
  let feesIncluded = 0
  let feesExcluded = 0
  const seenFees = new Map()

  taxesAndFees.forEach((fee) => {
    const desc = normalizeFeeDescription(fee.description || '')
    const feeKey = `${desc.toLowerCase()}_${fee.amount}`
    if (seenFees.has(feeKey)) return
    seenFees.set(feeKey, true)

    const amount = Number(fee.amount) || 0
    if (fee.included === true) feesIncluded += amount
    else if (fee.included === false) feesExcluded += amount
  })

  return { feesIncluded, feesExcluded }
}

export function getDisplayPricingFromRate({ rate, roomType, nights = 1, commissionFallback = 0 }) {
  const retailTotal = Number(rate?.retailRate?.total?.[0]?.amount || roomType?.offerRetailRate?.amount || 0)
  if (!retailTotal || retailTotal <= 0) return null

  const commission = Number(rate?.commission?.[0]?.amount || commissionFallback || 0)
  const taxesAndFees = rate?.retailRate?.taxesAndFees || []
  const { feesIncluded: rawFeesIncluded, feesExcluded } = getDedupedFeeTotals(taxesAndFees)
  const feesIncluded = rawFeesIncluded > retailTotal * 0.8 ? 0 : rawFeesIncluded
  const safeNights = Math.max(1, nights || 1)

  return {
    retailTotal,
    baseRate: retailTotal,
    commission,
    feesIncluded,
    feesExcluded,
    taxesAndFeesDisplay: commission + feesIncluded,
    nightlyRate: (retailTotal - commission - feesIncluded) / safeNights,
    totalPrice: retailTotal + feesExcluded,
    suggestedSellingPrice: Number(
      roomType?.suggestedSellingPrice?.amount || rate?.retailRate?.suggestedSellingPrice?.[0]?.amount || 0
    ) || null,
    rawTaxesAndFees: taxesAndFees,
  }
}
